module.exports = __webpack_public_path__ + "img/sparkling.fe9fbc48.png";